import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CeoProfilePage.css'; 
import { FaArrowLeft, FaGraduationCap, FaAward, FaBriefcase } from 'react-icons/fa';

import ceoPhoto from '../assets/images/ceo/GiovanniScarvaci.png'; 

// *******************************************************************
// DATOS DE LA BIOGRAFÍA DETALLADA 
// *******************************************************************
const DETAILED_BIO = {
    // ... (El objeto de datos permanece igual)
    FORMACION: [
        "Egresado en la Primera Promoción de Abogados de la Facultad de Derecho de la Universidad Bicentenaria de Aragua (UBA) en 1999.",
        "Economista por la Universidad de Carabobo en 1978.",
        "Estudios superiores en Derecho Mercantil y Derecho Procesal.",
        "Perito Avaluador del Instituto Politécnico de las Fuerzas Armadas (1990) y Diplomado en Locución de la UCV (1996)."
    ],
    TRAYECTORIA_Y_DOCENCIA: `Desde 1991 hasta 2017, fue docente universitario, impartiendo clases en materias como Derecho Mercantil, Economía Política, Derecho Probatorio y Avalúos. Ha sido profesor invitado en el Colegio de Abogados del Estado Aragua, compartiendo su experiencia en Derecho Concursal y Títulos de Crédito.`,
    EXPERIENCIA_LEGAL: `Desde 1999, ejerce como abogado litigante, especializándose en Derecho Inquilinario, Civil y Mercantil. Su experiencia abarca sociedades mercantiles, fusiones, escisiones, liquidaciones, conflictos de socios y gerencia corporativa. También ha trabajado como Perito Avaluador independiente para diversas instituciones financieras y bancarias.`,
    CERTIFICACIONES: "INPREABOGADO, Colegio de Economistas del Estado Aragua, SUDEBAN, Superintendencia de la Actividad Aseguradora, SUDEASEG, Ajustador de Perdidas Ramos Patrimoniales, FOGADE, AVALA, ASOTARAGUA, SOVECTA. Perito Avaluador Banco de Venezuela, Banco Industrial de Venezuela, BANDES, Banco del Tesoro, Banco Exterior y Banesco. Comisario de Empresas. Gerente General de la Cámara de Industriales del Estado Aragua.",
    RECONOCIMIENTOS: "Orden Francisco de Miranda y galardonado como Gerente del Año en Empresas de Gas Licuado de Petróleo en cinco ocasiones."
};

const formatCertifications = (text) => {
    const listItems = text.split(',').map(item => item.trim());
    return (
        <ul className="cert-list">
            {listItems.map((item, index) => (
                <li key={index}><FaAward size={10} style={{marginRight: '8px', color: '#3b5998'}} />{item}</li>
            ))}
        </ul>
    );
};

const CeoProfilePage = () => {
    const navigate = useNavigate();

    return (
        <div className="ceo-page-container">
            
            <h1> Dr. Giovanni Scarvaci</h1>
            
            <div className="ceo-main-info">
                <img src={ceoPhoto} alt="Dr. Giovanni Scarvaci" className="ceo-profile-photo-lg" />
                
                <div className="ceo-titles">
                    <h2>Abogado, Economista, Perito Avaluador</h2>
                    <p>Fundador de Giovanni Scarvaci & Asociados.</p>
                    <p className="ceo-slogan-text">
                        Más de 30 años de experiencia liderando soluciones estratégicas, garantizando probidad, lealtad y conocimiento.
                    </p>
                </div>
            </div>
            
            <div className="ceo-bio-full">
                <p>Giovanni Scarvaci es un profesional con una trayectoria multifacética, dedicada a ofrecer soluciones estratégicas y de alta calidad en Venezuela. Su formación como Abogado, Economista y Perito Avaluador, le confiere una visión integral única, especialmente valiosa en casos que combinan aspectos mercantiles, financieros y patrimoniales.</p>
                
                <h4 className="bio-sub-title"><FaGraduationCap /> Trayectoria Académica y Formación</h4>
                <ul className="academic-list">
                    {DETAILED_BIO.FORMACION.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
                
                <h4 className="bio-sub-title"><FaBriefcase /> Experiencia Legal y Docencia</h4>
                <p>{DETAILED_BIO.TRAYECTORIA_Y_DOCENCIA}</p>
                <p><strong>Especialización Legal:</strong> {DETAILED_BIO.EXPERIENCIA_LEGAL}</p>
                
                <h4 className="bio-sub-title"><FaAward /> Certificaciones y Afiliaciones</h4>
                <p>Su compromiso con la profesión se refleja en sus numerosas certificaciones y licencias profesionales, además de la recepción de la **{DETAILED_BIO.RECONOCIMIENTOS}**.</p>
                
                <div className="cert-list-container">
                    {formatCertifications(DETAILED_BIO.CERTIFICACIONES)}
                </div>
            </div>
            
            {/* SECCIÓN DE LIBROS CON ENLACE A PASARELA */}
            <section className="books-section">
                <h3>📚 Libros Publicados: "Los Secretos del Derecho Mercantil"</h3>
                <p>Adquiere aquí la versión digital de las publicaciones del Dr. Scarvaci y accede a contenido legal de vanguardia.</p>
                <button 
                    className="cta-button primary"
                    // 🛑 CORRECCIÓN CLAVE: La ruta debe ser /libro para coincidir con App.js
                    onClick={() => navigate('/libro')} 
                >
                    Comprar Libro Digital
                </button>
            </section>

            {/* BOTÓN DE NAVEGACIÓN AL FINAL DE LA PÁGINA */}
            <div className="navigation-footer">
                <button 
                    className="back-to-home-button" 
                    onClick={() => navigate('/')} 
                >
                    <FaArrowLeft /> Volver al Inicio
                </button>
            </div>
        </div>
    );
};

export default CeoProfilePage;